"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Jun 28 2018
 */

var immutable_1 = require("immutable");

var moment = require("moment");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");

var DateUtils_1 = require("../../core/utils/DateUtils");
/**
 * <p>
 *     General representation of group of sites. Group of sites is related to internal sites only. Group of sites can be updated within
 *     nighttime imports. Any site can be situated in multiple group of sites. There is special case of group of sites called implicit
 *     group of sites. These groups of sites include only one site, where {@link InternalSite#externalId} equals to external id of group
 *     of sites.
 * </p>
 *
 * <p>
 *     It is assumed that once a site has been assigned to a group of sites, it will be always included within #sitesBinding (its eventually
 *     cancelling from the sites binding will be determined by the date set in external system).
 * </p>
 *
 * @author JMe
 */


var GroupOfSites =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(GroupOfSites, _StateDomainObject_1$);

  /**
   * @param id the internal id
   * @param externalId the external id, i.e. from source data
   * @param name the name of group of sites
   * @param sitesBinding
   * @param stateFlags
   */
  function GroupOfSites(id, externalId, name) {
    var _this;

    var sitesBinding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : immutable_1.List();
    var stateFlags = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, GroupOfSites);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GroupOfSites).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    _this.sitesBinding = sitesBinding;
    _this.stateFlags = stateFlags;
    return _this;
  }
  /**
   * Adds given binding. It checks, whether binding containing the site id exists and if it does,
   * it checks valid from date – if it exists, it updates valid to, otherwise adds binding as new item.
   * @param binding the binding
   * @returns updated group of sites
   */


  _createClass(GroupOfSites, [{
    key: "addBinding",
    value: function addBinding(binding) {
      return this.copy('sitesBinding', this.removeBinding(binding).sitesBinding.push(binding));
    }
    /**
     * Removes given binding (based on site id and valid from).
     * @param binding the binding to remove
     * @returns updated group of sites
     */

  }, {
    key: "removeBinding",
    value: function removeBinding(binding) {
      if (this.sitesBinding.size === 0) {
        return this;
      }

      var index = this.sitesBinding.findIndex(function (r) {
        return r.siteId === binding.siteId && r.validFrom.isSame(binding.validFrom);
      });
      return index === -1 ? this : this.copy('sitesBinding', this.sitesBinding.remove(index));
    }
    /**
     * @returns true if group of sites contains at least one site valid at the moment, false otherwise.
     */

  }, {
    key: "includesAtLeastOneValidSite",
    value: function includesAtLeastOneValidSite() {
      var now = moment.utc(); // HERE !!!

      return this.sitesBinding.some(function (item) {
        return now.isSameOrAfter(item.validFrom) && now.isSameOrBefore(item.validTo);
      });
    }
    /**
     * @returns list of Site IDs for valid Group of sites bindings.
     */

  }, {
    key: "getValidSiteIds",
    value: function getValidSiteIds(date) {
      var bindings = this.sitesBinding.filter(function (item) {
        return date.isSameOrAfter(item.validFrom) && date.isSameOrBefore(item.validTo);
      });

      if (bindings.size > 0) {
        return bindings.map(function (binding) {
          return binding.siteId;
        });
      }

      return immutable_1.List.of();
    }
    /**
     * @returns Set of Site IDs that are bound to the group at least one day of given interval.
     */

  }, {
    key: "getBoundSiteIds",
    value: function getBoundSiteIds(dateFrom, dateTo) {
      return this.sitesBinding.filter(function (b) {
        return DateUtils_1.DateUtils.overlaps(b.validFrom, b.validTo || dateTo, dateFrom, dateTo);
      }).map(function (b) {
        return b.siteId;
      }).toSet();
    }
    /**
     * @returns True, if the site given is bound to the group at least one day of given interval.
     */

  }, {
    key: "isSiteBoundedInInterval",
    value: function isSiteBoundedInInterval(dateFrom, dateTo, siteId) {
      return this.sitesBinding.some(function (binding) {
        return binding.siteId === siteId && DateUtils_1.DateUtils.overlaps(binding.validFrom, binding.validTo || dateTo, dateFrom, dateTo);
      });
    }
    /**
     * @returns Get a Set of all Site IDs in this GOS
     */

  }, {
    key: "getAllSiteIds",
    value: function getAllSiteIds() {
      return this.sitesBinding.map(function (b) {
        return b.siteId;
      }).toSet();
    }
  }]);

  return GroupOfSites;
}(StateDomainObject_1.StateDomainObject);

exports.GroupOfSites = GroupOfSites;

GroupOfSites.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(GroupOfSites.name);
  return {
    id: builder.id('id'),
    externalId: builder.id('externalId'),
    name: builder.str('name'),
    sitesBinding: builder.listOf(builder.data('sitesBinding', {
      siteId: builder.str('siteId'),
      validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
      validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)
    })),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag)
  };
}();